import React from 'react'
import MobileDetect from 'mobile-detect'
import Banners from '../src/components/Banners/Banners'
import Home from '../src/components/mobilePages/Home/Home'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'

export default function HomeIndex(props) {
    // eslint-disable-next-line react/prop-types
    if (props.mobile) {
        return <Home />
    }
    return <Banners />
}

export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    customize({ context }) {
        const md = new MobileDetect(context.req.headers['user-agent'])
        return {
            props: {
                mobile: md.mobile()
            }
        }
    }
})
